/* VAIRE on Shopify: maps Liquid-rendered products into the VAIRE_PRODUCTS shape.
   This replaces assets/js/data/products.js from the mockup. Runs synchronously
   before store.js so every downstream module is untouched. */
(function () {
  'use strict';
  var src = window.VAIRE_SHOPIFY || [];
  var clean = function (s) { return String(s || '').replace(new RegExp('[' + String.fromCharCode(8211, 8212) + ']', 'g'), ', ').replace(/\s+/g, ' ').trim(); };
  function excerpt(s, max) {
    if (!s || s.length <= max) return s;
    var sentence = s.match(/^.*?[.!?](?:\s|$)/);
    if (sentence && sentence[0].trim().length <= max) return sentence[0].trim();
    return s.slice(0, max + 1).replace(/\s+\S*$/, '').trim() + '...';
  }
  function subcat(t) {
    var s = t.toLowerCase();
    if (/lip oil/.test(s)) return 'lip oil';
    if (/lip.*(mask|balm|sleeping|care)/.test(s)) return 'lip care';
    if (/gloss/.test(s)) return 'lip gloss';
    if (/lipstick|lip colou?r|lip liner/.test(s)) return 'lipstick';
    if (/foundation|filter|skin tint|bb /.test(s)) return 'tint';
    if (/concealer/.test(s)) return 'concealer';
    if (/brow/.test(s)) return 'brow';
    if (/mascara|lash serum/.test(s)) return 'mascara';
    if (/blush/.test(s)) return 'blush';
    if (/bronzer/.test(s)) return 'bronzer';
    if (/highlight/.test(s)) return 'highlighter';
    if (/liner/.test(s)) return 'eyeliner';
    if (/shadow|palette/.test(s)) return 'eyeshadow palette';
    if (/gua sha|roller/.test(s)) return 'sculpt';
    if (/brush/.test(s)) return 'brush';
    if (/mirror|steamer|vacuum|device|led|microcurrent/.test(s)) return 'device';
    if (/curler|tweez|sharpen/.test(s)) return 'precision';
    if (/wash|cleansing|cleanser|rinse/.test(s)) return 'cleanser';
    if (/spf|sun/.test(s)) return 'spf';
    if (/mist|spray|setting/.test(s)) return 'mist';
    if (/mask|patch/.test(s)) return 'mask';
    if (/eye/.test(s)) return 'eye';
    if (/serum|ampoule/.test(s)) return 'serum';
    if (/cream|moistur|balm|milk|butter|jelly/.test(s)) return 'moisturizer';
    if (/body/.test(s)) return 'body';
    if (/set|duo|kit|collection|essentials|wardrobe|pack/.test(s)) return 'set';
    return 'treatment';
  }
  function departments(name, sc, type, tags) {
    var s = String(name || '').toLowerCase();
    var t = (type || '').toLowerCase();
    var tg = (tags || []).map(function (x) { return String(x).toLowerCase(); });
    var has = function (x) { return tg.indexOf(x) > -1; };
    var colourSubcats = ['lip oil', 'lip gloss', 'lipstick', 'tint', 'concealer', 'brow', 'mascara', 'blush', 'bronzer', 'highlighter', 'eyeliner', 'eyeshadow palette'];
    var toolSubcats = ['brush', 'sculpt', 'device', 'precision'];
    var primary = 'skin';

    /* The live 15-tag taxonomy is more reliable than title order. Keep one
       primary department for homepage scenes, then add Sets as a useful
       overlapping catalog filter. */
    if (has('hair') || /hair|scalp|scrunch|pillowcase|claw clip/.test(s)) primary = 'hair';
    else if (has('body') || /body|bath|foot peel/.test(s)) primary = 'body';
    else if (t === 'tools' || has('tools') || has('devices') || toolSubcats.indexOf(sc) > -1) primary = 'tools';
    else if (t === 'colour' || t === 'color' || has('lips') || has('brow') || has('complexion') || colourSubcats.indexOf(sc) > -1) primary = 'colour';

    var out = [primary];
    if (has('sets') || /set|duo|kit|collection|wardrobe|pack of|six pack|pieces/.test(s)) out.push('sets');
    return { primary: primary, all: out };
  }
  function shadeHex(name) {
    var s = String(name || '').toLowerCase();
    var colors = [
      ['black|noir|charcoal', '#211F1D'], ['white|ivory|cream', '#EEE7DA'], ['clear|transparent', '#E8E3DA'],
      ['wine|burgundy|berry', '#6E2938'], ['plum|aubergine', '#674456'], ['mauve', '#A56F7D'],
      ['rose|rosy|blush', '#C58B91'], ['pink|petal', '#D9A0AA'], ['red|crimson|cherry', '#A9363E'],
      ['coral|peach', '#D88F73'], ['orange|tangerine', '#C87546'], ['gold|champagne', '#C9A96A'],
      ['brown|chocolate|coffee|espresso', '#6B493C'], ['tan|caramel|sand|beige|nude', '#B89276'],
      ['green|sage|olive', '#78806C'], ['blue|navy', '#59697D'], ['purple|violet|lilac', '#8B7292'],
      ['silver|gray|grey', '#A7A5A0']
    ];
    for (var i = 0; i < colors.length; i++) if (new RegExp(colors[i][0]).test(s)) return colors[i][1];
    return '#C9B28A';
  }
  var ACT = { skin: [0, 5], body: [0, 5], hair: [0, 5], colour: [5, 10], tools: [10, 15] };
  var counts = { skin: 0, body: 0, hair: 0, colour: 0, tools: 0 };

  window.VAIRE_PRODUCTS = src.map(function (r, i) {
    /* Shopify keeps the brand-qualified title for SEO and channel feeds. The
       storefront already carries the VAIRE wordmark, so repeating it at the
       start of every visible product name makes the edit feel catalogued rather
       than curated. Remove only the leading display prefix here. */
    var name = clean(r.title).replace(/^VAIRE\s+/i, '');
    var sc = subcat(name), dept = departments(name, sc, r.product_type, r.tags), c = dept.primary;
    var variants = r.variants || [];
    /* Liquid's {{ product | json }} emits money as integer cents */
    var cents = function (x) { var n = parseFloat(x); return isNaN(n) ? 0 : n / 100; };
    var prices = variants.map(function (v) { return cents(v.price); }).filter(function (n) { return n > 0; });
    var price = prices.length ? Math.min.apply(null, prices) : 0;
    var cmp = variants.map(function (v) { return cents(v.compare_at_price); }).filter(function (n) { return n > price; });
    var shades = null;
    if (variants.length > 1) {
      shades = variants.map(function (v) {
        var optionName = clean(v.title === 'Default Title' ? name : v.title);
        /* The owner keeps every live variant purchasable and the Admin record is
           normalized to inventoryPolicy CONTINUE. Do not let a stale Liquid
           availability cache paint a sellable sibling as unavailable. */
        return { name: optionName, hex: shadeHex(optionName), priceDelta: Math.round((cents(v.price) - price) * 100) / 100, variantId: v.id, available: true, image: v.featured_image && v.featured_image.src ? v.featured_image.src : null };
      });
    }
    var k = counts[c]++;
    var a = ACT[c];
    /* Shopify's Liquid product JSON exposes the rich description as `description`.
       Keep the full HTML for the PDP and derive a short plain-text card blurb. */
    var descriptionHtml = String(r.description || r.body_html || '');
    var descriptionText = clean(descriptionHtml.replace(/<[^>]+>/g, ' '));
    return {
      id: r.handle, no: i + 1, name: name,
      category: c, departments: dept.all, subcategory: sc,
      price: price, compareAt: cmp.length ? Math.max.apply(null, cmp) : null,
      blurb: descriptionText ? excerpt(descriptionText, 170) : 'Part of the Vaire line.',
      desc: descriptionHtml || 'Details arriving with the full launch.',
      howto: 'Use as directed on the packaging, morning or night.',
      ingredients: 'Full ingredient list on the product packaging.',
      vessel: 'bottle', colorway: { body: '#E4CDA9', accent: '#C9B28A', cap: '#16120E' },
      shades: shades,
      available: variants.length > 0,
      tags: (r.tags || []).map(function (t) { return String(t).toLowerCase(); }),
      edit: null,
      timecode: '00:00:' + ('0' + (a[0] + (k % (a[1] - a[0])))).slice(-2) + ':' + ('0' + ((k * 7) % 24)).slice(-2),
      releasedAt: String(r.published_at || r.created_at || '').slice(0, 10),
      images: (r.images || []).map(function (im) { return im.src || im; }),
      variantIds: variants.map(function (v) { return v.id; }),
      url: '/products/' + r.handle,
    };
  });

  var byHandle = function (id) { return window.VAIRE_PRODUCTS.some(function (p) { return p.id === id; }) ? id : null; };
  var pick = function (fn) { var p = window.VAIRE_PRODUCTS.filter(fn)[0]; return p && p.id; };
  var curated = {
    film: {
      skin: 'jojoba-oil-hyaluronic-acid-shimmer-body-oil-dermatologist-tested-anti-aging-korean-skin-care-deep-hydration-plumping-glow-with-vanilla-latte-scent-vegan-clean-beauty-3-38-fl-oz',
      colour: '12pcs-liquid-lipstick-set-shades-with-matte-gloss-lip-tint-set-a-waterproof-long-lasting-quick-drying-non-stick-cup-up-to-12h-wear-professional-lip-makeup-gift-kit',
      tools: '3d-face-roller-eye-wand-massager-kit-facial-massage-tool-for-women-girls-premium-stainless-steel-metal-portable-ergonomic-design-safe-for-all-skin-types-2-in-1-skincare-set'
    },
    home: {
      skin: [
        'jojoba-oil-hyaluronic-acid-shimmer-body-oil-dermatologist-tested-anti-aging-korean-skin-care-deep-hydration-plumping-glow-with-vanilla-latte-scent-vegan-clean-beauty-3-38-fl-oz',
        'pdrn-serum-rejuvenating-peptide-face-serum-with-salmon-dna-korean-skincare-for-anti-aging-hydration-collagen-boost-and-barrier-repair-brightening-daily-skincare-for-dark-spots-and-uneven-tone',
        'the-glow-getter-whipped-multi-oil-body-butter-firming-cream-body-moisturizer-with-shea-butter-7-7-fl-oz',
        'heartleaf-85-calming-toner-for-face-85-heartleaf-extract-hydrating-korean-toner-jeju-houttuynia-cordata-extract-for-sensitive-skin-ph-balanced-korean'
      ],
      colour: [
        '12pcs-liquid-lipstick-set-shades-with-matte-gloss-lip-tint-set-a-waterproof-long-lasting-quick-drying-non-stick-cup-up-to-12h-wear-professional-lip-makeup-gift-kit',
        '3d-face-creator-cream-foundation-concealer-12-hours-long-lasting-medium-to-full-coverage-non-greasy-ideal-for-makeup-contour-palette-level-3',
        'matte-lip-liner-set-12-colors-long-lasting-waterproof-nude-lip-liner-pencil-set-smooth-and-high-pigmented-natural-lip-makeup-pencil-matte-makeup-lipliners',
        'glow-reviver-lip-oil-jam-session-nourishing-tinted-lip-oil-for-a-high-shine-finish-infused-with-jojoba-oil-vegan-cruelty-free'
      ],
      tools: [
        '10pcs-eye-makeup-brushes-set-eyeshadow-blending-angled-brow-travel-bag-upgraded-eye-shadow-brush-set-professional-shading-defining-cruelty-free-vegan-for-beginner-makeup-artist-recommendation',
        '3d-face-roller-eye-wand-massager-kit-facial-massage-tool-for-women-girls-premium-stainless-steel-metal-portable-ergonomic-design-safe-for-all-skin-types-2-in-1-skincare-set',
        'compact-mirror-with-light-4-inches-compact-1x-10x-magnifying-mirror-double-sides-lighted-3-colors-lighting-0-100-brightness-diammable-touch-1200mah-rechargeable-for-pocket-purse',
        '4-drawers-makeup-organizer-bathroom-organizers-and-storage-plastic-bins-countertop-perfume-vanity-desk-organization-for-cosmetic-skincare-face-mask-jewelry-gold'
      ]
    }
  };
  window.VAIRE_HOME_CURATED = curated.home;
  window.VAIRE_FEATURED = {
    skin: byHandle(curated.film.skin) || pick(function (p) { return p.category === 'skin'; }),
    colour: byHandle(curated.film.colour) || pick(function (p) { return p.category === 'colour'; }),
    set: byHandle(curated.film.tools) || pick(function (p) { return p.category === 'tools'; })
  };
})();
